<template>
    <div>
        <!-- Botão para gerar PDF -->
        <b-button variant="danger" class="float-right" @click="downloadPdf">
            <i class="fas fa-download"></i> Baixar PDF
        </b-button>

        <!-- Componente VueHtml2pdf com todo o conteúdo inline -->
        <VueHtml2pdf class="d-none" :show-layout="false" :float-layout="true" :enable-download="true"
            :preview-modal="true" :filename="`ticket_info_${ticket.protocol}`" :pdf-quality="2" :manual-pagination="true" pdf-format="a4"
            pdf-orientation="portrait" ref="html2Pdf">
            
            <section slot="pdf-content">
                <div style="padding: 20px; font-family: Arial, sans-serif;">
                    <h1 style="color: #2e8b8b; border-bottom: 2px solid #2e8b8b; padding-bottom: 10px;">Ticket #{{ ticket.protocol }}</h1>

                    <div style="background: #f8f9fa; padding: 15px; border-radius: 6px; margin-bottom: 20px;">
                        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px;">
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Protocolo:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.protocol }}</div>
                            </div>
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Cliente:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.client }}</div>
                            </div>
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">E-mail:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.email[0] }}</div>
                            </div>
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Atendente:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.owner_user?.name ?? "" }}</div>
                            </div>

                            <div v-if="ticket.keyword?.keyword">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Palavra-chave:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.keyword?.keyword ?? "" }}</div>
                            </div>
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Grupo:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.owner_group?.name ?? "" }}</div>
                            </div>
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Status:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.status.name }}</div>
                            </div>
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Prioridade:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.priority.name }}</div>
                            </div>
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Criado em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(ticket.created_at) }}</div>
                            </div>
                            
                            
                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Atualizado em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(ticket.updated_at) }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Vencimento em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ handleTicketSLAExpirationDate(ticket) }}</div>
                            </div>

                            <div v-if="ticket?.received_at">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Recebido em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(ticket.received_at) }}</div>
                            </div>
                            
                            <div v-if="ticket?.closed_at">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Concluído em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(ticket.closed_at) }}</div>
                            </div>

                            <div v-if="ticket?.closed_by">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Concluído por:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ ticket.closed_by }}</div>
                            </div>
                        </div>
                    </div>

                    <div style="background: white; border: 1px solid #ddd; border-radius: 6px; padding: 20px; margin-bottom: 20px;" v-if="allEmails?.length">
                        <h4 style="margin-bottom: 15px; color: #333;">📧 Conteúdo dos e-mails</h4>
                        
                        <div v-for="(email, index) in allEmails" :key="email.id" style="margin-bottom: 20px; border: 1px solid #eee; padding: 15px; border-radius: 6px;">
                            <div style="border-bottom: 1px solid #c2c2c2; padding-bottom: 10px; margin-bottom: 10px;">
                                <h5 style="margin-bottom: 10px;">{{ email.subject }}</h5>
                                <p style="margin: 5px 0;"><strong>{{ email.is_received ? "Recebido" : "Enviado" }} em: </strong>{{ formatDate(email.created_at) }}</p>
                                <p style="margin: 5px 0;"><strong>De: </strong>{{ handleEmailsArray(email.from_email) }}</p>
                                <p style="margin: 5px 0;"><strong>Para: </strong>{{ handleEmailsArray(email.to_email) }}</p>
                                <p v-if="email.copy_email?.length" style="margin: 5px 0;">
                                    <strong>Cópia: </strong>{{ handleEmailsArray(email.copy_email) }}
                                </p>
                            </div>
                            
                            <div v-html="email.body" style="margin: 10px 0;"></div>
                            
                            <div v-if="email.attachments && email.attachments?.length > 0" style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #eee;">
                                <h5 style="font-size: 13px; margin: 0 0 10px 0; color: #333;">Anexos ({{ email.attachments?.length }}):</h5>
                                <ul style="list-style: none; padding: 0; margin: 0;">
                                    <li v-for="(attachment, attachIndex) in email.attachments" :key="attachIndex" style="margin-bottom: 5px;">
                                        • {{ attachment.filename }} ({{ formatFileSize(attachment.size) }})
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div style="background: white; border: 1px solid #ddd; border-radius: 6px; padding: 15px; margin-bottom: 20px;" v-if="ticket.comments?.length">
                        <h4 style="margin-bottom: 15px; color: #333;">💬 Comentários</h4>
                        
                        <div v-for="comment in ticket.comments" :key="comment.id" style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #eee;">
                            <div style="font-weight: bold; font-size: 12px; margin-bottom: 2px;">{{ comment?.created_by?.name ?? "" }}</div>
                            <div style="font-size: 10px; color: #666; margin-bottom: 5px;">{{ formatDate(comment.created_at) }}</div>
                            <div style="font-size: 11px; color: #333; line-height: 1.4;">{{ comment.text }}</div>
                        </div>
                    </div>

                    <div style="background: white; border: 1px solid #ddd; border-radius: 6px; padding: 15px;" v-if="ticket.timeline?.length">
                        <h4 style="margin-bottom: 15px; color: #333;">🕒 Linha do Tempo</h4>
                        
                        <div v-for="event in ticket.timeline" :key="event.id" style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #eee;">
                            <div style="font-weight: bold; font-size: 12px; margin-bottom: 2px;">{{ event.event }}</div>
                            <div style="font-size: 10px; color: #666; margin-bottom: 5px;">{{ formatDate(event.created_at) }}</div>
                            <div style="font-size: 11px; color: #333; line-height: 1.4;">{{ event.detail }}</div>
                        </div>
                    </div>
                </div>
            </section>
            
        </VueHtml2pdf>
    </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import {
    convertSecondsToTime,
    dinamicStyle,
    handleTicketSLA,
    formatDate,
    isTimeWithinPercentage,
    getFileIcon,
    formatFileSize,
    textSizeLimit,
    handleTicketSLAExpirationDate,
} from '../../../helpers/utils';

export default {
    name: "TicketPDF",
    components: {
        VueHtml2pdf,
    },
    props: {
        ticket: {
            type: Object,
            default: () => { }
        },
        emails: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        allEmails: [],
    }),
    created() {
        if (this.emails?.length) {
            this.allEmails = this.emails;
        } else {
            this.getAllEmails();
        }
    },
    methods: {
        convertSecondsToTime,
        dinamicStyle,
        handleTicketSLA,
        formatDate,
        isTimeWithinPercentage,
        getFileIcon,
        formatFileSize,
        textSizeLimit,
        handleTicketSLAExpirationDate,
        async getAllEmails() {
            try {
                const { data } = await axios.get("emails/listEmails", {
                    params: {
                        emails: this.ticket?.emails_ids,
                    }
                });

                if (data) this.allEmails = data;
            } catch (error) {
                console.error(error)
            }
        },
        handleEmailsArray(emails) {
            if (!Array.isArray(emails)) return emails;
            return emails.join("; ");
        },
        downloadPdf() {
            this.$refs.html2Pdf.generatePdf();
        },
        emailSubTitle(email) {
            if (email.is_received) {
                return `Recebido em: ${this.formatDate(email.created_at)}`;
            } else {
                return `Enviado em: ${this.formatDate(email.created_at)}`;
            }
        },
    },
}
</script>

<style scoped>
.modal-log {
    position: relative;
    margin: 10% auto;
    max-height: 50em;
    padding: 30px;
    max-width: 60em;
    border-radius: 4px !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
    background-color: #FAFAFA;
    overflow-y: auto;
}

.avoid-page-break {
    page-break-inside: avoid;
}
</style>

<style scoped>
.writter-comment-area {
    margin-top: 40px;
    border-top: 1px solid #c2c2c2;
    padding-top: 10px;
}

.email-content-area {
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
}

.email-content-area>h4 {
    margin-bottom: 15px;
    color: #333;
}

.email-content-body {
    border-bottom: 1px solid #e6e6e6;
    margin: 10px 0px;
}

.email-content-header {
    border-bottom: 1px solid #c2c2c2;
    padding-bottom: 10px;
}

.btns-edit {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
}

.input-edit-mode {
    height: 30px;
    width: 100%;
    font-size: 14px;
    border: 1px solid #c2c2c2;
    border-radius: 5px !important;
    padding: 2px 5px;
}

.ticket-id {
    font-weight: bold;
    color: #2e8b8b;
    cursor: pointer;
}

.ticket-id:hover {
    text-decoration: underline;
}

.highlight-badge {
    padding: 5px 10px;
    border-radius: 5px !important;
    font-size: 12px;
    font-weight: bold;
}

.status-atendimento {
    background-color: #fff3e0;
    color: #ef6c00;
}

.status-aguardando {
    background-color: #f3e5f5;
    color: #7b1fa2;
}

.status-resolvido {
    background-color: #e8f5e8;
    color: #2e7d32;
}

.sla-indicator {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 10px;
}

.sla-circle {
    width: 12px;
    height: 12px;
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: bold;
}

.sla-ok {
    background: #4caf50;
    color: white;
}

.sla-warning {
    background: #ff9800;
    color: white;
}

.sla-critical {
    background: #f44336;
    color: white;
}

.sla-overdue {
    background: #d32f2f;
    color: white;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.ticket-details {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
}

.ticket-info {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 6px !important;
    margin-bottom: 5px;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.info-label {
    font-size: 10px;
    color: #666;
    font-weight: bold;
    text-transform: uppercase;
}

.info-value {
    font-size: 12px;
    color: #333;
    font-weight: 500;
}

.timeline {
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px !important;
    padding: 15px;
}

.timeline-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
}

.timeline-item {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    position: relative;
}

.timeline-item:not(:last-child)::after {
    content: '';
    position: absolute;
    left: 10px;
    top: 21px;
    width: 2px;
    height: calc(100% + 3px);
    background: #e0e0e0;
}

.timeline-icon {
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 50% !important;
    border: 1px solid #c2c2c2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: white;
    flex-shrink: 0;
    box-shadow: 1px 1px 1px black;
}

.timeline-content {
    flex: 1;
}

.timeline-title {
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 2px;
}

.timeline-time {
    font-size: 10px;
    color: #666;
    margin-bottom: 5px;
}

.timeline-description {
    font-size: 11px;
    color: #333;
    line-height: 1.4;
}

.timeline-label-events {
    background-color: #c1121f;
    color: white;
}

.internal-comment {
    background: #fff3cd;
    border-left: 3px solid #ffc107;
    padding: 8px;
    margin-top: 5px;
    border-radius: 0 4px 4px 0 !important;
}

.comment-section {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.comment-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.comment-input {
    width: 100%;
    min-height: 80px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px !important;
    font-size: 12px;
    resize: vertical;
}

.comment-actions {
    display: flex;
    gap: 10px;
}

.btn {
    padding: 8px 15px;
    border: 1px solid;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 11px;
    font-weight: bold;
    transition: all 0.3s;
}

.btn-primary {
    background-color: #2e8b8b;
    color: white;
    border-color: #2e8b8b;
}

.btn-primary:hover {
    background-color: #246969;
}

.btn-secondary {
    background-color: #6c757d;
    color: white;
    border-color: #6c757d;
}

.btn-warning {
    background-color: #ffc107;
    color: #333;
    border-color: #ffc107;
}

.ticket-details {
    grid-template-columns: 1fr;
}

.email-card-accordion {
    margin: 10px 0px;
}

.composer-attachments {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.composer-attachments>h5 {
    font-size: 13px;
    margin: 0 0 10px 0;
    color: #333;
}

.composer-attachments>ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.composer-attachments>ul>li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    border-radius: 4px;
    font-size: 12px;
    border: 1px solid #e9ecef;
    transition: background-color 0.2s;
    text-align: center;
}

.composer-attachments>ul>li:hover {
    background: #e9ecef;
}

.composer-attachments>ul>li>span {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    flex-grow: 1;
    justify-content: center;
}

.composer-attachments>ul>li>span>i {
    color: #2e8b8b;
    font-size: 18px;
    /* margin-bottom: 4px; */
}

.attachment-size {
    color: #6c757d;
    font-size: 10px;
}

.download-attachment-btn {
    background: none;
    border: none;
    color: #2e8b8b;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 3px;
    text-decoration: none;
    transition: all 0.2s;
    font-size: 12px;
}

.download-attachment-btn:hover {
    background-color: #2e8b8b;
    color: white;
    text-decoration: none;
}

/* Responsive grid for smaller screens */
@media (max-width: 768px) {
    .composer-attachments>ul {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .composer-attachments>ul {
        grid-template-columns: 1fr;
    }
}
</style>